import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer>
      <div className="footer-icons">
        <a href="https://www.facebook.com/share/1AXNSbsWnx/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
          <i className="fab fa-facebook"></i>
        </a>
        <a href="https://www.instagram.com/legrec14?igsh=MXVocG96Yzlna2RsMQ==" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
          <i className="fab fa-instagram"></i>
        </a>
        <a href="https://www.tiktok.com/@le.grec.tiaret?_t=ZM-8y7zc4OHSwH&_r=1" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
          <i className="fab fa-tiktok"></i>
        </a>
        <a href="https://maps.app.goo.gl/Nat6aiU9eignEUFJA?g_st=ipc" target="_blank" rel="noopener noreferrer" aria-label="Google Maps">
          <i className="fas fa-map-marker-alt"></i>
        </a>
      </div>
    </footer>
  );
};

export default Footer; 